export default "__VITE_ASSET__20e47848__"